import { render, staticRenderFns } from "./AddonMailerlite.vue?vue&type=template&id=47cd06fc&"
import script from "./AddonMailerlite.vue?vue&type=script&lang=js&"
export * from "./AddonMailerlite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports